import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import CategoryPrice from './CategoryPrice';
import styles from './CategoryRow.module.css';
import usePriceSettings from './use-pricesettings';
import CategoryTipJar from './CategoryTipJar';

const CategoryRow = (props) => {
  const {
    category,
    id: categoryId,
    price,
    tipJarPrice,
    clearSelection,
  } = props;

  const [checked, setChecked] = useState(false);
  const { priceSettings, handlePaywallChange, handleTipJarChange } =
    usePriceSettings(price, tipJarPrice, categoryId, category);

  const tipJar = {
    low: priceSettings.tipJarPrice[0],
    med: priceSettings.tipJarPrice[1],
    high: priceSettings.tipJarPrice[2],
  };

  const handleCategorySelection = (id, isChecked) => {
    props.setSelectedCategories((prevState) => {
      console.log(id, isChecked);
      prevState.set(id, isChecked);

      return new Map(prevState);
    });
  };

  useEffect(() => {
    if (clearSelection) {
      setChecked(false);
    }
  }, [clearSelection]);

  return (
    <tr className={styles['category-row']}>
      <div className={styles.grp_1}>
        <td className={styles.checkbox}>
          <input
            type="checkbox"
            name="category"
            id={categoryId}
            value={categoryId}
            onChange={(e) => {
              setChecked((p) => !p);
              // eslint-disable-next-line radix
              handleCategorySelection(parseInt(e.target.id), e.target.checked);
            }}
            checked={checked}
          />
        </td>
        <td className={styles.title}>
          <span>{category}</span>
        </td>
      </div>
      <div className={styles.grp_2}>
        <td className={styles.price}>
          <CategoryPrice
            price={priceSettings.paywallPrice}
            onPaywallChange={(paywall) => handlePaywallChange(paywall)}
          />
        </td>
        <CategoryTipJar
          /* eslint-disable react/jsx-props-no-spreading */
          {...tipJar}
          className={styles.price}
          onTipJarChange={(pTipJar) => handleTipJarChange(pTipJar)}
        />
      </div>
    </tr>
  );
};

CategoryRow.propTypes = {
  category: PropTypes.node.isRequired,
  id: PropTypes.node.isRequired,
  price: PropTypes.node.isRequired,
  tipJarPrice: PropTypes.node.isRequired,
  clearSelection: PropTypes.node.isRequired,
  setSelectedCategories: PropTypes.node.isRequired,
};

export default CategoryRow;
